
import { Component, Vue } from 'vue-property-decorator';
import Slick from 'vue-slick';

@Component({
  components: {
    Slick, // Slick 컴포넌트 등록
  },
})

export default class PopupComponent extends Vue {
  popupFlag = new Date() >= new Date('2026-02-10 00:00:00') && new Date() <= new Date('2026-02-10 23:59:59');

  showPopup = false;

  doNotShowToday = false;

  imageLoaded = false;

  isMobile = false;

  currentSlide = 0;

  get totalSlides() {
    return this.popupFlag ? 2 : 1;
  }

  mainBannerOptions = {
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 400,
    dots: false,

    draggable: true,
    pauseOnHover: false,
  };

  handleAfterChange(event: any, slick: any, currentSlide: number) {
    // vue-slick passes event, slick instance, and currentSlide
    this.currentSlide = currentSlide;
  }

  handleClickBannerSlide1(str: string) {
    const slick = (this.$refs.PopupBanner as any);
    if (str === 'next') {
      slick.next();
    } else {
      slick.prev();
    }
  }

  checkPopupStatus() {
    const savedDate = localStorage.getItem('hidePopupDate');
    const today = new Date().toISOString().split('T')[0];
    if (savedDate !== today) {
      this.showPopup = true;
    }
  }

  closePopup() {
    this.showPopup = false;
  }

  closePopup2() {
    const today = new Date().toISOString().split('T')[0];
    localStorage.setItem('hidePopupDate', today);
    this.showPopup = false;
  }

  onImageLoad() {
    this.imageLoaded = true;
  }

  mounted() {
    this.checkPopupStatus();
    if (window.innerWidth < 700) {
      this.isMobile = true;
    }
  }
}
